/**
 * Returns the CRM image URL with the appropriate prefix based on the current environment.
 * Uses dev prefix for localhost or dev environments, production prefix otherwise.
 *
 * @param {string} imagePath - The image path (e.g., project.image)
 * @returns {string} The full image URL
 */
export const getCrmImageUrl = (imagePath) => {
    if (!imagePath) return '';

    const hostname = window.location.hostname;
    const isDev = hostname.includes('localhost') || hostname.includes('dev');
    const prefix = isDev
        ? 'https://dev.crm.ruachtova.org.il/uploads/'
        : 'https://crm.ruachtova.org.il/uploads/';

    return `${prefix}${imagePath}`;
};
